<div class="container">
  <h3 class="title">User Added</h3>
  <ul>
    <app-user-row
      *ngFor="let user of users"
      [name]="user.name"
      [type]="user.type"
      (editUser)="handleEditUser({type:'', name:''})"
      (setDeleteModalOpened)="setDeleteModalOpened.emit($event)"
    ></app-user-row>
  </ul>
  <app-add-button
    (click)="handleOpenAddModal()"
    text="新增"
  ></app-add-button>
</div> 